import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import {
	MatDialogModule,
	MAT_DIALOG_DATA,
	MatDialogClose,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { map, Observable, startWith } from 'rxjs';
import { FormFieldLabelComponent } from '@app/shared/ui-components/form-field-label/form-field-label.component';

@Component({
	selector: 'edit-title-dialog',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule,
		NgxTolgeeModule,
		MatDialogClose,
		FormFieldLabelComponent,
	],
	templateUrl: './edit-title-dialog.component.html',
	styleUrl: './edit-title-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditTitleDialogComponent {
	private readonly dialogRef = inject(MAT_DIALOG_DATA) as string;

	maxLength = 100;

	titleControl = new FormControl(this.dialogRef || '', [
		Validators.required,
		Validators.maxLength(this.maxLength),
	]);

	currentLength$: Observable<number> = this.titleControl.valueChanges.pipe(
		startWith(this.titleControl.value),
		map(value => value?.length || 0)
	);
}
